import createApiUrl from 'sources/apiUrlCreator';
import { JSON_REQUEST, MULTIPART_REQUEST } from './helpers/requestTypes';
import { HTTP_OK } from './helpers/httpStatuses';
import { GET, PUT, POST } from './helpers/httpMethods';
import ApiError from './helpers/ApiError';

export default class BaseApi {
  constructor() {
    this.baseUrl = createApiUrl();

    this.API_NAME = '';
  }

  get apiBaseUrl() {
    return this.baseUrl;
  }

  get apiName() {
    return this.API_NAME;
  }

  async getRequest(path, options = {}) {
    const { params } = options;
    return this.makeRequest(GET, path, { params });
  }

  async postRequest(path, options = {}) {
    const { data, params, files } = options;
    if (files && Object.keys(files).length) {
      const formData = BaseApi.getFormData(data, files);

      return this.makeRequest(
        POST,
        path,
        {
          data: formData,
          params,
        },
        MULTIPART_REQUEST,
      );
    }
    const json = JSON.stringify(data);

    return this.makeRequest(POST, path, { data: json, params });
  }

  async putRequest(path, { data, params, files }) {
    if (files && Object.keys(files).length) {
      const formData = BaseApi.getFormData(data, files);

      return this.makeRequest(
        PUT,
        path,
        {
          data: formData,
          params,
        },
        MULTIPART_REQUEST,
      );
    }

    const json = JSON.stringify(data);

    return this.makeRequest(PUT, path, { data: json, params });
  }

  async makeRequest(method, path, data = {}, type = JSON_REQUEST) {
    const headers = {
      Accept: type,
      'Content-Type': type,
    };
    const query = BaseApi.queryParams(data.params);
    const response = await fetch(
      `${this.apiBaseUrl}/${this.apiName}/${path}${query ? `?${query}` : ''}`,
      {
        method,
        headers,
        credentials: 'include',
        body: data.data,
      },
    );

    const result = await BaseApi.getResultFromResponse(response);
    return result;
  }

  static queryParams(params = {}) {
    return Object.keys(params)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
      .join('&');
  }

  static async getResultFromResponse(response) {
    const json = await response.json();

    if (json.code !== HTTP_OK) {
      throw new ApiError(json);
    }

    return json.result;
  }

  static getFormData(data, files) {
    const formData = new FormData();

    const dataKeys = data && Object.keys(data);
    if (dataKeys.length) {
      dataKeys.map(key => {
        formData.append(key, data[key]);
      });
    }

    const filesKeys = files && Object.keys(files);

    if (filesKeys.length) {
      filesKeys.map(key => {
        formData.append(key, data[key]);
      });
    }

    return formData;
  }
}



// WEBPACK FOOTER //
// ./src/api/BaseApi.js